import React, { ReactNode } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

interface Props {
    children: ReactNode;
}

const PublicRoute = ({ children, ...rest }: Props & RouteProps) => {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

    return (
        <Route
            {...rest}
            render={({ location }) =>
                isAuthenticated ? (
                    <Redirect
                        to={{
                            pathname: "/buat-ukm",
                            state: { from: location },
                        }}
                    />
                ) : (
                    children
                )
            }
        />
    );
};

export default PublicRoute;
